import {
  Stack, SimpleGrid, Skeleton,
} from '@mantine/core';
import { IconReceipt } from '@tabler/icons-react';
import PageHeader from '@/components/PageHeader';
import StatCard from '@/components/StatCard';
import EmptyState from '@/components/EmptyState';
import { useSpendingSummary } from '@/hooks/usePortalApi';

function formatCurrency(val: number) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val);
}

export default function SpendingDashboard() {
  const { data, isLoading } = useSpendingSummary();

  return (
    <Stack gap="lg">
      <PageHeader title="Spending Dashboard" description="Overview of your spending and purchasing trends" />
      {isLoading ? (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
          {[...Array(3)].map((_, i) => <Skeleton key={i} height={120} radius="md" />)}
        </SimpleGrid>
      ) : !data ? (
        <EmptyState icon={<IconReceipt size={30} />} title="No spending data" description="No spending data available" />
      ) : (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
          <StatCard
            title="Total Spend (30 Days)"
            value={formatCurrency(data.total_30d ?? 0)}
            icon={<IconReceipt size={24} />}
            trend={data.trend}
          />
          <StatCard
            title="Total Spend (90 Days)"
            value={formatCurrency(data.total_90d ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Total Spend (YTD)"
            value={formatCurrency(data.total_ytd ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Average Order Value"
            value={formatCurrency(data.avg_order_value ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Total Orders"
            value={String(data.total_orders ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Outstanding Balance"
            value={formatCurrency(data.outstanding_balance ?? 0)}
            icon={<IconReceipt size={24} />}
          />
        </SimpleGrid>
      )}
    </Stack>
  );
}
